module.exports = __webpack_public_path__ + "static/DeclineCoverSliderImage-0b09fd8aa8c6968329761bfaae36f26a.jpeg";